/**
 * Created by piotr.pozniak@thebeaverhead.com on 18/07/2023
 */
import React from "react";
import QueueJobsListPage from "./QueueJobsPage/QueueJobsListPage";

const QueuedWebhookJobs = () => (
  <QueueJobsListPage
    title="Webhook jobs"
    jobType="SyncOne"
    routeBase="/webhook-jobs"
    hasDuration
    hasAutoLogin
  />
);

export default QueuedWebhookJobs;
